import axios, { InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";

import msalInstance, { getToken } from "./msalInstance";


const axiosInstance = axios.create({
    baseURL: "https://ai-dev.fetch.dev.com",
    headers: {
        "Content-Type": "application/json"
    }
});

axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
        try {
            const token = await getToken();
            if (token) {
                config.headers = {
                    ...config.headers.toJSON(), 
                    Authorization: `Bearer ${token}`
                } as AxiosRequestHeaders; 
            }
        } catch (error) {
            console.warn("error in token")
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
